export const AUTH_NAVY = '#0B2545';
export const AUTH_NAVY_MID = '#13315C';
export const AUTH_NAVY_LIGHT = '#1B4175';
export const AUTH_GOLD = '#C5A55A';

export const AUTH_PAGE_STYLES = `
.auth-page {
  min-height: 100vh;
  display: flex;
  background: linear-gradient(135deg, #F3F6FB 0%, #F7F9FC 48%, #F8F5ED 100%);
  color: ${AUTH_NAVY};
  font-family: 'Avenir Next', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.auth-page .ant-typography,
.auth-page .ant-btn,
.auth-page .ant-input,
.auth-page .ant-form,
.auth-page a,
.auth-page span,
.auth-page div {
  font-family: inherit;
}

.auth-page-left {
  position: relative;
  flex: 0 0 53%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 56px;
  overflow: hidden;
  background: linear-gradient(135deg, ${AUTH_NAVY} 0%, ${AUTH_NAVY_MID} 52%, ${AUTH_NAVY_LIGHT} 100%);
}

.auth-page-left::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px),
    linear-gradient(180deg, rgba(255,255,255,0.015) 1px, transparent 1px),
    radial-gradient(circle at 16% 22%, rgba(197,165,90,0.08), transparent 24%),
    radial-gradient(circle at 78% 76%, rgba(73,169,255,0.08), transparent 28%);
  background-size: 64px 64px, 64px 64px, auto, auto;
  opacity: 0.35;
  pointer-events: none;
}

.auth-page-left::after {
  content: '';
  position: absolute;
  inset: 14% 17%;
  border-radius: 42px;
  border: 1px solid rgba(255,255,255,0.04);
  background: linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
  box-shadow: inset 0 0 60px rgba(255,255,255,0.02);
  pointer-events: none;
}

.auth-brand-orbit {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.04);
}

.auth-brand-orbit.top {
  top: -120px;
  right: -80px;
  width: 320px;
  height: 320px;
}

.auth-brand-orbit.bottom {
  bottom: -90px;
  left: -70px;
  width: 220px;
  height: 220px;
}

.auth-brand-content {
  position: relative;
  z-index: 1;
  width: min(100%, 468px);
}

.auth-brand-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid rgba(197,165,90,0.24);
  background: rgba(197,165,90,0.08);
  color: ${AUTH_GOLD};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.auth-brand-logo {
  margin-top: 24px;
  display: flex;
  align-items: center;
  min-height: 54px;
}

.auth-brand-logo img {
  max-width: 252px;
  max-height: 54px;
  object-fit: contain;
  display: block;
}

.auth-brand-logo-text {
  color: #FFFFFF !important;
  font-size: 48px !important;
  line-height: 1 !important;
  margin: 0 !important;
  font-weight: 700 !important;
  letter-spacing: -0.035em;
}

.auth-brand-copy {
  max-width: 430px;
  margin: 28px 0 0 !important;
  color: rgba(255,255,255,0.82) !important;
  font-size: 17px !important;
  line-height: 1.9 !important;
}

.auth-brand-signature {
  margin-top: 28px;
  padding-top: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  border-top: 1px solid rgba(255,255,255,0.08);
}

.auth-brand-signature-item {
  color: rgba(255,255,255,0.7);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.auth-page-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  overflow-y: auto;
  background:
    radial-gradient(circle at 12% 18%, rgba(197,165,90,0.1), transparent 24%),
    linear-gradient(180deg, #FAFBFD 0%, #F6F8FB 100%);
}

.auth-shell {
  width: 100%;
  max-width: 460px;
}

.auth-shell-wide {
  max-width: 520px;
}

.auth-card.ant-card {
  position: relative;
  border: 1px solid rgba(19,49,92,0.08);
  border-radius: 30px;
  background: rgba(255,255,255,0.92);
  box-shadow: 0 28px 60px rgba(11,37,69,0.1);
  backdrop-filter: blur(16px);
  overflow: hidden;
}

.auth-card.ant-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(135deg, rgba(197,165,90,0.06), rgba(197,165,90,0) 28%),
    radial-gradient(circle at top right, rgba(73,169,255,0.08), transparent 20%);
  pointer-events: none;
}

.auth-card .ant-card-body {
  position: relative;
  z-index: 1;
  padding: 38px 36px 32px;
}

.auth-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}

.auth-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid rgba(197,165,90,0.22);
  background: rgba(197,165,90,0.08);
  color: ${AUTH_NAVY};
  font-size: 12px;
  font-weight: 700;
}

.auth-badge .anticon {
  color: ${AUTH_GOLD};
}

.auth-back-link {
  color: #6B7A90;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.auth-back-link:hover {
  color: ${AUTH_NAVY};
}

.auth-header {
  margin-bottom: 28px;
}

.auth-title {
  margin: 0 0 10px !important;
  color: ${AUTH_NAVY} !important;
  font-size: 34px !important;
  line-height: 1.18 !important;
  font-weight: 700 !important;
}

.auth-subtitle {
  color: #65758D !important;
  font-size: 15px !important;
  line-height: 1.8 !important;
}

.auth-form .ant-form-item {
  margin-bottom: 18px;
}

.auth-input.ant-input-affix-wrapper,
.auth-input.ant-input-password {
  height: 54px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid rgba(19,49,92,0.1);
  background: #F8FAFD;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.7);
}

.auth-input.ant-input-affix-wrapper:hover,
.auth-input.ant-input-affix-wrapper-focused,
.auth-input.ant-input-password:hover,
.auth-input.ant-input-password-focused {
  border-color: rgba(11,37,69,0.2);
  box-shadow: 0 0 0 4px rgba(19,49,92,0.05);
}

.auth-input .ant-input {
  background: transparent;
  font-size: 16px;
}

.auth-input .ant-input::placeholder {
  color: #9AA7B8;
}

.auth-input .ant-input-prefix {
  margin-right: 10px;
  color: #7A8798;
}

.auth-input .ant-input-password-icon {
  color: #9AA7B8;
}

.auth-submit.ant-btn {
  height: 52px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, ${AUTH_NAVY} 0%, ${AUTH_NAVY_MID} 100%);
  box-shadow: 0 18px 30px rgba(11,37,69,0.18);
  font-size: 17px;
  font-weight: 700;
}

.auth-submit.ant-btn:hover,
.auth-submit.ant-btn:focus {
  background: linear-gradient(135deg, ${AUTH_NAVY_MID} 0%, ${AUTH_NAVY_LIGHT} 100%) !important;
}

.auth-divider.ant-divider {
  margin: 28px 0 14px;
}

.auth-link-copy {
  text-align: center;
}

.auth-link-accent {
  color: ${AUTH_GOLD};
  font-size: 17px;
  font-weight: 700;
  text-decoration: none;
  border-bottom: 1px solid rgba(197,165,90,0.38);
}

.auth-page--register .auth-page-right {
  padding: 24px 28px;
  overflow: hidden;
}

.auth-shell-register {
  max-width: 560px;
}

.auth-card--register.ant-card {
  max-height: calc(100vh - 48px);
}

.auth-card--register .ant-card-body {
  padding: 24px 26px 20px;
}

.auth-card--register .auth-topbar {
  margin-bottom: 14px;
}

.auth-card--register .auth-badge {
  padding: 6px 10px;
  font-size: 11px;
}

.auth-card--register .auth-header {
  margin-bottom: 16px;
}

.auth-card--register .auth-title {
  margin-bottom: 6px !important;
  font-size: 30px !important;
}

.auth-card--register .auth-subtitle {
  font-size: 14px !important;
  line-height: 1.65 !important;
}

.auth-card--register .auth-form .ant-form-item {
  margin-bottom: 12px;
}

.auth-input--compact.ant-input-affix-wrapper,
.auth-input--compact.ant-input-password {
  height: 46px;
  border-radius: 14px;
}

.auth-consent-wrap {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(19,49,92,0.08);
  background: rgba(248, 250, 253, 0.92);
}

.auth-consent-tip {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(217, 54, 62, 0.08);
  color: #D9363E;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.auth-card--register .auth-submit.ant-btn {
  height: 46px;
  font-size: 16px;
}

.auth-card--register .auth-divider.ant-divider {
  margin: 18px 0 10px;
}

.auth-page.is-dark {
  background: #08111F;
}

.auth-page.is-dark .auth-page-right {
  background: linear-gradient(180deg, #091324 0%, #0B1628 100%);
}

.auth-page.is-dark .auth-card.ant-card {
  border-color: rgba(255,255,255,0.08);
  background: rgba(12,23,40,0.86);
  box-shadow: 0 28px 60px rgba(0,0,0,0.26);
}

.auth-page.is-dark .auth-title {
  color: #FFFFFF !important;
}

.auth-page.is-dark .auth-subtitle,
.auth-page.is-dark .auth-back-link,
.auth-page.is-dark .auth-divider .ant-divider-inner-text {
  color: rgba(255,255,255,0.58) !important;
}

.auth-page.is-dark .auth-badge {
  color: #FFFFFF;
  background: rgba(197,165,90,0.1);
}

.auth-page.is-dark .auth-input.ant-input-affix-wrapper,
.auth-page.is-dark .auth-input.ant-input-password {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.1);
}

.auth-page.is-dark .auth-consent-wrap {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.08);
}

.auth-page.is-dark .auth-input .ant-input,
.auth-page.is-dark .auth-input .ant-input::placeholder,
.auth-page.is-dark .auth-input .ant-input-prefix,
.auth-page.is-dark .auth-input .ant-input-password-icon {
  color: rgba(255,255,255,0.76);
}

@media (max-width: 1100px) {
  .auth-page {
    flex-direction: column;
  }

  .auth-page-left,
  .auth-page-right {
    flex: none;
    width: 100%;
  }

  .auth-page-right {
    order: 1;
    padding: 30px 20px 44px;
  }

  .auth-page-left {
    order: 2;
    min-height: 40vh;
    padding: 44px 28px 38px;
  }

  .auth-page-left::after {
    inset: 10% 7%;
  }
}

@media (max-width: 640px) {
  .auth-page-left {
    min-height: auto;
    padding: 26px 18px 24px;
  }

  .auth-brand-content {
    width: 100%;
  }

  .auth-brand-logo {
    margin-top: 18px;
    min-height: 40px;
  }

  .auth-brand-logo img {
    max-width: 208px;
    max-height: 40px;
  }

  .auth-brand-logo-text {
    font-size: 40px !important;
  }

  .auth-brand-copy {
    margin-top: 22px !important;
    font-size: 15px !important;
    line-height: 1.78 !important;
  }

  .auth-brand-signature {
    margin-top: 22px;
    gap: 10px;
    padding-top: 14px;
  }

  .auth-brand-signature-item {
    font-size: 10px;
    letter-spacing: 0.1em;
  }

  .auth-card .ant-card-body {
    padding: 28px 22px 24px;
  }

  .auth-page--register .auth-page-right {
    padding: 18px 14px 24px;
    overflow-y: auto;
  }

  .auth-card--register.ant-card {
    max-height: none;
  }

  .auth-card--register .ant-card-body {
    padding: 22px 18px 20px;
  }

  .auth-topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .auth-title {
    font-size: 28px !important;
  }
}
`;
